import { Layer, Source } from "react-map-gl/maplibre";

interface EmptyLayersProps {
  beforeId?: string;
}

export const EMPTY_LAYER = "empty-layer-";
export const FIRST_EMPTY_LAYER = "empty-layer-0";

export function EmptyLayers({ beforeId }: EmptyLayersProps) {
  return (
    <Source id="empty-source" type="raster">
      {/* these 100 layers are needed for ordering layers with beforeId
      https://github.com/visgl/react-map-gl/issues/939#issuecomment-625290200 */}
      {new Array(100).fill(1).map((_, i) => {
        return (
          <Layer
            key={EMPTY_LAYER + i}
            id={EMPTY_LAYER + i}
            type="background"
            layout={{ visibility: "none" }}
            beforeId={beforeId}
          />
        );
      })}
    </Source>
  );
}
